import React, { Component } from 'react';

import ARButton from './ARButton';

export default class ARPrimaryButton extends Component {
    render() {
        const props = {...this.props};

        props.buttonType = "ar-primary-btn";

        return (
            <ARButton
                {...props}
            >
                {props.children}
            </ARButton>
        )
    }
}